import styled from 'styled-components';

export const BottomNavigationContainer = styled.div`
position: fixed;
bottom: 0;
width: 100%;
`;